import {RequestEntity} from "../../../../types/RequestEntity";
import {isSingleRequest} from "../../../../lib/isSingleRequest";
import Tooltiper from "components/Tooltiper";
import {isCombinedRequest} from "../../../../lib/isCombinedRequest";
import React from "react";


// Компонент рендеринга ячейки для имени спортивного объекта
export const SportObjectNameCellRenderer = React.memo(function SportObjectNameCellRenderer({equipmentRequestEntity}: { equipmentRequestEntity: RequestEntity }) {
    return (
        <>
            {isSingleRequest(equipmentRequestEntity) &&
                <Tooltiper text={equipmentRequestEntity?.sportObject?.name}/>
            }
            {isCombinedRequest(equipmentRequestEntity) &&
                <Tooltiper
                    text={
                        Array.from(new Set(equipmentRequestEntity?.childRequests
                            ?.map((request) => request.sportObject?.name)
                            .filter(name => name)
                        )).join(', ')
                    }
                />}
        </>
    );
}, (prevProps, nextProps) => {
    const prev = prevProps.equipmentRequestEntity;
    const next = nextProps.equipmentRequestEntity;
    
    if (isSingleRequest(prev) && isSingleRequest(next)) {
        return (
            prev.id === next.id &&
            prev.sportObject?.id === next.sportObject?.id &&
            prev.sportObject?.name === next.sportObject?.name
        );
    }
    
    if (isCombinedRequest(prev) && isCombinedRequest(next)) {
        const prevNames = Array.from(new Set(prev.childRequests?.map(r => r.sportObject?.name).filter(Boolean) || [])).sort().join(', ');
        const nextNames = Array.from(new Set(next.childRequests?.map(r => r.sportObject?.name).filter(Boolean) || [])).sort().join(', ');
        return prev.id === next.id && prevNames === nextNames;
    }
    
    return false;
});